export const roles = {
  ANONYMOUS: "anonymous",
  SITE_MEMBER: "site-member",
  BUSINESS_ADMIN: "business-admin",
  SECURITY_OFFICER: "security-officer",
  DEVELOPER: "developer",
  EVENT_ORGANIZER: "event-organizer"
};